import { useLocalStorage } from '@mantine/hooks';

import { DEFAULT_RATE_FILTERS, isRateServiceTypeFilter } from './rate-filtering';

import type { RateFilters } from './rate-filtering';

export const RATE_FILTERS_STORAGE_KEY = 'freightRatesFilters';

const deserializeRateFilters = (value: string | undefined): RateFilters => {
  if (value === undefined) return DEFAULT_RATE_FILTERS;

  try {
    const parsed: unknown = JSON.parse(value);
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return DEFAULT_RATE_FILTERS;

    const { serviceType } = parsed as Record<string, unknown>;
    if (serviceType === null || serviceType === undefined) return DEFAULT_RATE_FILTERS;
    return isRateServiceTypeFilter(serviceType) ? { serviceType } : DEFAULT_RATE_FILTERS;
  } catch {
    return DEFAULT_RATE_FILTERS;
  }
};

export const useRateFilters = (): [RateFilters, (next: RateFilters) => void] => {
  const [filters, setFilters] = useLocalStorage<RateFilters>({
    key: RATE_FILTERS_STORAGE_KEY,
    defaultValue: DEFAULT_RATE_FILTERS,
    deserialize: deserializeRateFilters,
  });

  return [filters, setFilters];
};
